import { render, staticRenderFns } from "./TermsDialog.vue?vue&type=template&id=43f80272"
import script from "./TermsDialog.vue?vue&type=script&lang=ts"
export * from "./TermsDialog.vue?vue&type=script&lang=ts"
import style0 from "./TermsDialog.vue?vue&type=style&index=0&id=43f80272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports